<template>
  <div>
    <b-row>
      <b-col xl="8">
        <api-keys />
        <account-details />
      </b-col>
      <b-col xl="4">
        <plan />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ApiKeys from './Account/ApiKeys'
import AccountDetails from './Account/AccountDetails'
import Plan from './Account/Plan'

export default {
  components: {
    ApiKeys,
    AccountDetails,
    Plan,
  }
}
</script>
<style>
</style>
